export default __webpack_public_path__ + "static/media/back.fff0f867.svg";